import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from '../../../auth/login/login';
import { AngularFireAuth } from 'angularfire2/auth';


/**
 * Generated class for the HomeDashboardTopopSalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-user-block',
  templateUrl: 'home-user-block.html',
})
export class HomeUserBlock {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    public afAuth: AngularFireAuth) {

  }

  openVersionPro() {
    //link a wordpress
    if (this.globals.restaurant.license == 'free') {
      this.globals.openPayBasicMonthBlank();
    } else if (this.globals.restaurant.license == 'basic') {
      this.globals.openPayProMonthBlank();
    } else if (this.globals.restaurant.license == 'pro') {
      this.globals.openPayBusinessMonthBlank();
    }
  }

  logout() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-cerrar-sesion'),
      message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.delNotTokenAndLogout();
          }
        }
      ]
    });
    alert.present();
  }

  async delNotTokenAndLogout() {
    //funcion que borra token
    await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
    //hacemos logout de afAuth
    this.afAuth.auth.signOut()
      .then(authData => {
        // toast message
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cerrado-sesion'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
          this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
        }

        this.navCtrl.setRoot(LoginPage);
        window.location.reload();
      }, error => {
        //var errorMessage: string = error.message;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-user-block/home-user-block.ts